import { combineReducers } from "@reduxjs/toolkit";
import { History } from "history";
import { connectRouter } from "connected-react-router";
import {
    advancedDate,
    clientSlice,
    colorSlice,
    layoutSlice,
    periodSlice,

} from "./features";



const createRootReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history),
        colorSlice,
        layoutSlice,
        clientSlice,
        periodSlice,
        advancedDate,
    });

export default createRootReducer;
